/* One-Shot First Image Pin — minimal & no-conflict
   - Forces the FIRST gallery image on initial load
   - Stops after ~1s or as soon as the user interacts
   - Does not observe or override anything afterwards
*/
(() => {
  if (window.__PS_FIRSTPIN__) return; // prevent double-run
  window.__PS_FIRSTPIN__ = true;

  const SLIDER_SEL    = '.Product__Slideshow.Carousel';
  const NAV_THUMB_SEL = '.Product__SlideshowNavImage';
  const SLIDE_SEL     = '.Product__SlideItem[data-media-id]';

  const OPTION_CLICK_SEL = '.fabric-option, .fabric-type-option, .carousel-cell, .depth-option, .SizeSwatch';

  const q  = (s, r=document) => r.querySelector(s);
  const qa = (s, r=document) => Array.from(r.querySelectorAll(s));

  function getFlkty(){
    const el = q(SLIDER_SEL);
    return (window.Flickity && el) ? Flickity.data(el) : null;
  }

  let userActAt = 0;
  const now = () => performance.now();

  // If user touches options or thumbs, stop pinning immediately
  document.addEventListener('pointerdown', e => {
    if (e.target.closest(OPTION_CLICK_SEL) || e.target.closest(NAV_THUMB_SEL)) {
      userActAt = now();
    }
  }, true);

  function pinFirstOnce(){
    const fl = getFlkty();
    if (fl) {
      if (fl.selectedIndex !== 0) fl.select(0, false, true);
      return true;
    }
    // Fallback: click first thumb if Flickity not ready yet
    const firstNav = q(NAV_THUMB_SEL);
    if (firstNav) { firstNav.click(); return true; }

    // Last fallback: click the slide’s matching thumb by media-id
    const firstSlide = qa(SLIDE_SEL)[0];
    if (firstSlide) {
      const id = firstSlide.getAttribute('data-media-id');
      const nav = q(`.Product__SlideshowNavImage[data-media-id="${id}"]`);
      if (nav) { nav.click(); return true; }
    }
    return false;
  }

  function start(){
    // Try immediately
    pinFirstOnce();

    // Re-try briefly for late inits/DPO races – but bail on user action
    const startAt = now();
    const timer = setInterval(() => {
      if (userActAt && now() - userActAt < 2000) { clearInterval(timer); return; }
      const ok = pinFirstOnce();
      // stop after a successful pin + small delay OR after 1200ms
      if ((ok && now() - startAt > 200) || now() - startAt > 1200) {
        clearInterval(timer);
      }
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
